import React from 'react'
import {seoPageChange} from '../../utils'

class BlogPost extends React.Component {

  constructor(props) {
    super(props);
  }

  componentDidMount() { seoPageChange() }

  render() {

    const { title } = this.props;

    return (
      <section className="BlogPost grid-restrain-narrow grid-row">
        <div className="content markdown-blog grid-item">
          {title && (<h1 className="blog-title">{title}</h1>)}
          {this.props.children}
        </div>
      </section>
    )
  }

}

export default BlogPost;



// WEBPACK FOOTER //
// ./src/components/marketing/BlogPost.js